import { toSnakeCase } from 'packages/helper'

export const transformRequestToSnakeCase = (data: any) => JSON.stringify(toSnakeCase(data))
